import React, { useState } from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import Select from "react-select";
import {Link} from "react-router-dom";
import CustomerLink from '../../Components/CustomerLink';

// StoreMarkers component
const WaypointMarkers = ({
                          storeLocations,
                          markerPositions,
                          zoomedIn,
                          handleMarkerDragEnd,
                          handleDeleteStoreLocation,
                          handleResetStorePosition,
                          userIds, // Pass the userIds from the parent component or hook
                          assignCustomerData, // Function to call the assign API
                      }) => {
    const [selectedStore, setSelectedStore] = useState(null); // Track the selected store
    const [selectedUserId, setSelectedUserId] = useState(""); // Track the selected user

    return (
        <>
            {storeLocations.map((storeLocation) => {
                const position =
                    markerPositions[storeLocation.uid]?.newPosition ||
                    [storeLocation.latitude, storeLocation.longitude];

                const customIcon = L.divIcon({
                    html: `
        <div style="position: relative; text-align: center;">
            <div style="
                position: absolute;
                top: -20px;
                left: 50%;
                transform: translateX(-50%);
                background-color: white;
                padding: 2px 5px;
                border-radius: 3px;
                font-size: 12px;
                font-weight: bold;
                color: black;
                z-index: 1000; /* High z-index */
                pointer-events: none; /* Prevent interference with map interactions */
                box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
            ">
                ${storeLocation.waypointId}
            </div>
            <img src="${
                        storeLocation.purchaseToday
                            ? "/store2-icon.png"
                            : "https://upload.wikimedia.org/wikipedia/commons/archive/9/96/20070110004130%21Dot-yellow.svg"
                    }" style="z-index: 999;" />
        </div>
    `,
                    className: "custom-icon",
                    iconSize: [40, 40], // Adjust if needed
                    iconAnchor: [0, 0], // Adjust for icon alignment
                    popupAnchor: [0, -40], // Adjust to match label
                });


                return (
                    <Marker
                        key={storeLocation.id}
                        position={position}
                        icon={customIcon}
                        draggable={true}
                        eventHandlers={{
                            dragend: (event) => handleMarkerDragEnd(event, storeLocation.id),
                        }}
                    >
                        <Popup>
                            <div
                                style={{
                                    maxWidth: "250px",
                                    fontFamily: "Arial, sans-serif",
                                    fontSize: "14px",
                                    color: "#333",
                                }}
                            >
                                {/* Store Name */}
                                <h3
                                    style={{
                                        margin: "0 0 10px 0",
                                        fontSize: "16px",
                                        color: "#0275d8",
                                        textAlign: "center",
                                    }}
                                >
                                    <CustomerLink name={storeLocation.storeName} code={storeLocation.customerUid || storeLocation.uid} type={storeLocation.customerType} />
                                </h3>


                                <p style={{margin: "5px 0"}}>
                                    <strong>ID:</strong> {storeLocation.waypointId}
                                </p>

                                {/* Latitude and Longitude */}
                                <p style={{margin: "5px 0"}}>
                                    <strong>Latitude:</strong> {position[0]}
                                </p>
                                <p style={{margin: "5px 0"}}>
                                    <strong>Longitude:</strong> {position[1]}
                                </p>
                                <p style={{margin: "5px 0"}}>
                                    <strong>ระยะจากร้านค้า:</strong> {storeLocation.distandToNearestStore}
                                </p>

                                <p style={{margin: "5px 0"}}>
                                    <strong>ระยะจากร้านค้า:</strong> {storeLocation.nearestStoreName}
                                </p>


                                {/* Map Actions */}
                                <div className={"btc-MapIcon"} style={{marginTop: "10px", textAlign: "center"}}>
                                    <i
                                        className="fa-solid fa-map"
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                            color: "gray",
                                            marginRight: "10px"
                                        }}
                                        onClick={() => {
                                            const mapUrl = `https://www.google.com/maps/place/${position[0]}+${position[1]}/@${position[0]},${position[1]},150m`;
                                            window.open(mapUrl, "_blank");
                                        }}
                                    ></i>
                                    <span
                                        onClick={() => handleResetStorePosition(storeLocation.id)}
                                        style={{
                                            color: "#0275d8",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                            marginRight: "10px",
                                        }}
                                        title="Reset Position"
                                    >
                                        <i className="fas fa-redo-alt" style={{color: "gray"}}></i>
                                    </span>
                                    <span
                                        onClick={() => {
                                            if (window.confirm("Are you sure you want to delete this store?")) {
                                                handleDeleteStoreLocation(storeLocation.id);
                                            }
                                        }}
                                        style={{
                                            color: "#d9534f",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                        }}
                                        title="Delete Store"
                                    >
                                        <i className="fas fa-trash-alt"
                                           style={{color: "gray", marginRight: "10px"}}></i>
                                    </span>
                                    <span
                                        onClick={() => setSelectedStore(storeLocation)}
                                        style={{
                                            color: "#f0ad4e",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                        }}
                                        title="Assign Seller"
                                    >
                                        <i className="fa-solid fa-truck-fast" style={{color: "gray"}}></i>
                                    </span>


                                    <Link
                                        to={`/customerData/edit/${storeLocation.customerUid || storeLocation.id}`}
                                        state={{
                                            customerData: storeLocation,
                                            newLatitude: position[0],  // Ensure position is properly defined
                                            newLongitude: position[1]
                                        }}

                                        style={{fontSize: "20px"}}
                                    >
                                        <i className="fas fa-edit" style={{color: 'gray'}}></i>
                                    </Link>

                                </div>
                            </div>
                        </Popup>
                    </Marker>
                );
            })}

            {/* User selection popup */}
            {selectedStore && (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "white",
                        padding: "20px",
                        borderRadius: "10px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        zIndex: 1000,
                    }}
                >
                    <h3 style={{textAlign: "center", color: "#000000"}}>
                        ตั้งสายที่รับผิดชอบ ให้กับ {selectedStore.storeName}
                    </h3>
                    <select
                        value={selectedUserId}
                        onChange={(e) => setSelectedUserId(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "10px",
                            margin: "10px 0",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                        }}
                    >
                        <option value="">เลือกสายที่รับผิดชอบ</option>
                        {userIds && userIds.map((user) => (
                            <option key={user.uid} value={user.uid}>
                                {user.nameuser} ({user.username})
                            </option>
                        ))}
                    </select>

                    <div style={{textAlign: "center", marginTop: "10px"}}>
                        <button
                            onClick={() => {
                                if (selectedUserId && selectedStore) {
                                    assignCustomerData(selectedUserId, selectedStore.uid); // Pass correct arguments
                                    setSelectedStore(null);
                                    setSelectedUserId("");
                                } else {
                                    alert("Please select a seller and store.");
                                }
                            }}
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#474545",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                marginRight: "10px",
                            }}
                        >
                            บันทึก
                        </button>
                        <button
                            onClick={() => {
                                setSelectedStore(null);
                                setSelectedUserId("");
                            }}
                            style={{
                                padding: "10px 20px",
                                color: "#5a5a5a",
                                backgroundColor:"white",
                                border: "2px solid #5a5a5a",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        >
                            ยกเลิก
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default WaypointMarkers;
